import {
  Box,
  LinearProgress,
  Stack,
  useTheme,
} from "@mui/material";
import Grisha from "../../assets/grisha.png";

export const LoadPage = () => {
  const theme = useTheme();

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.background.default,
        overflow: "hidden",
      }}
    >
      <Stack
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: 90, sm: 110, md: 135 },
            height: { xs: 50, sm: 60, md: 70 },
          }}
        >
          <img
            width="100%"
            height="100%"
            loading="lazy"
            src={Grisha}
            alt="GrishaEmpty"
          />
        </Box>

        <LinearProgress
          sx={{ width: { xs: 100, sm: 110, md: 135 }, borderRadius: 5 }}
          color="primary"
        />
      </Stack>
    </Box>
  );
};
